module.exports = __webpack_public_path__ + "img/guide15.a681349b.jpg";